import React from 'react';
import './portfolio.scss';
import { Paper } from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Link } from 'react-router-dom';
import { IRouteMetadata } from 'src/components/layout/appDrawer/types/auth-response.model';

export default function PlanPortfolio({
  pagesData
}: {
  pagesData: IRouteMetadata[];
}) {
  // clonng pagesData deeply
  let clonedPagesData: IRouteMetadata[] = JSON.parse(JSON.stringify(pagesData));
  let resData = clonedPagesData.filter((e) => e.parent.name === 'simulator')[0];
  const childrenElements = resData.children.filter((e) => e.parent.is_visible);
  return (
    <div>
      {childrenElements.map((ele) => (
        <Paper
          className='accordian-content'
          variant='outlined'
          sx={{ backgroundColor: '#fbfbfb', m: '4px 0px' }}
        >
          <Link to={ele.parent.route_url}>
            <div className='flex-aligned-div'>
              <div className='content-title-div'>
                <div className='content-main-title'>{ele.parent.alias}</div>
                <div className='content-sub-title'>
                  {ele.parent.description}
                </div>
              </div>
              <KeyboardArrowRightIcon sx={{ color: 'black' }} />
            </div>
          </Link>
        </Paper>
      ))}

      {/* <div className="module-list-div">
        <ul>
          {resData.children.map((childEle) => (
            <li style={{ listStyleType: "disc" }}>
              <div className="main-title">{childEle.parent.alias}</div>
              <div className="sub-title">{childEle.parent.description}</div>
            </li>
          ))}
        </ul>
      </div> */}
    </div>
  );
}
